module.exports = __webpack_public_path__ + "static/img/23_yewei.874f8517.png";